/* tslint:disable no-string-literal */
import { Component, OnInit, Input, Output, EventEmitter, Renderer2, Inject, OnChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { ToolTransferService } from 'src/app/component/tools/tool-transfer/tool-transfer.service';
import { DOCUMENT } from '@angular/common';
import { AutoCompleteFetchModel } from 'src/app/component/shared/autocomplete/autocomplete.model';
import { JobParams } from '../../../tools/tool-transfer/tool-transfer.model';
import { PermissionsService } from 'src/app/service/auth/permissions.service';
import { ToolInventoryTransferService } from 'src/app/component/tools/tool-inventory-transfer/tool-inventory-transfer.service';

@Component({
  selector: 'app-configuration-settings-bar',
  templateUrl: './configuration-settings-bar.component.html',
  styleUrls: ['./configuration-settings-bar.component.scss'],
})
export class ConfigurationSettingsBarComponent implements OnInit, OnChanges {
  jobParams = JobParams;

  @Input() searchBarSide = 'right';
  @Input() editAccess = true;
  @Input() configurationSettingsData: any;
  @Input() filters: Array<any> = [];
  @Input() moreFilters: Array<any> = [];
  @Input() source: string;
  @Output() search = new EventEmitter<string>();
  @Output() create = new EventEmitter<string>();

  filterType: string;
  searchFilters: any = {};
  transferCount = 0;
  inventoryCount = 0;
  searchInput = '';
  fleetVehicleInput = '';
  private toolSubscription: Subscription;
  private inventorySubscription: Subscription;
  list;
  exportType: string;
  selectedDateRange: any = '';
  assignmentFilterProps = {};
  rentalRatesIncluded: boolean = false;

  constructor(
    private toolTransferService: ToolTransferService,
    private toolInventoryTransferService: ToolInventoryTransferService,
    /* tslint:disable-next-line variable-name */
    @Inject(DOCUMENT) public _document,
    public renderer2: Renderer2,
    public permissionsService: PermissionsService,
  ) {}

  ngOnInit(): void {
    this.toolTransferService.loadFromLocalStorage();
    this.toolInventoryTransferService.loadFromLocalStorage();
    this.toolSubscription = this.toolTransferService.selectedItems.subscribe(data => (this.transferCount = data.length));
    this.inventorySubscription = this.toolInventoryTransferService.selectedInventoryItems.subscribe(data => (this.inventoryCount = data.length));


    this.loadOptionsData();
    if (this.moreFilters) this.loadMoreOptionsData();
    this.loadSelect2();
    setTimeout(() => this.loadSelect2MultipleWithCheck(), 700);
  }

  ngOnDestroy() {
    if (this.toolSubscription) this.toolSubscription.unsubscribe();
    if (this.inventorySubscription) this.inventorySubscription.unsubscribe();
  }

  capitalize(word) {
    return word[0].toUpperCase() + word.slice(1).toLowerCase();
  }

  isAllowed(resource: string, action: string) {
    const resources = {
      job_pointe_configuration: 'job_pointe_configuration',
    };
    const resource1 = resources[resource];
    return this.permissionsService.allow({ resource1, action });
  }

  loadSelect2MultipleWithCheck(className = '.select2MultipleWithCheck') {
    const s1 = this.renderer2.createElement('script');
    s1.type = 'text/javascript';
    s1.text = `loadSelect2MultipleWithCheck('` + className + `','Status');`;
    this.renderer2.appendChild(this._document.body, s1);
  }

  loadSelect2() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `loadSelect2();`;
    this.renderer2.appendChild(this._document.body, s);
  }

  ngOnChanges() {}

  async loadOptionsData() {
    const promiseList = this.filters.map(async filter => {
      if (typeof filter.loadOptions === 'function') {
        const options = await filter.loadOptions();
        filter.options = options;
      }
    });
    await Promise.all(promiseList);
  }
  handleSave(e) {}

  async loadMoreOptionsData() {
    const promiseList = this.moreFilters.map(async filter => {
      if (typeof filter.loadOptions === 'function') {
        const options = await filter.loadOptions();
        filter.options = options;
      }
    });
    await Promise.all(promiseList);
  }

  checkIsSelected(id, type) {
    const searchData = this.searchFilters[type];
    if (searchData && searchData.includes(id)) {
      return true;
    } else {
      return false;
    }
  }

  triggerChange(obj) {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `triggerChangeWithValue('` + obj + `');`;
    this.renderer2.appendChild(this._document.body, s);
  }

  clearSelect2MultipleWithCheck(className = '.select2MultipleWithCheck') {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `clearSelect2MultipleWithCheck('` + className + `');`;
    this.renderer2.appendChild(this._document.body, s);
  }

  setSelect2MultipleWithCheck(className = '.select2MultipleWithCheck', searchInfo = {}) {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `setSelect2MultipleWithCheck('` + className + `', [` + searchInfo['status'] + `]);`;
    this.renderer2.appendChild(this._document.body, s);
    const s1 = this.renderer2.createElement('script');
    s1.type = 'text/javascript';
    s1.text = `setSelect2MultipleWithCheck('` + className + `', [` + searchInfo['assetClasses'] + `]);`;
    this.renderer2.appendChild(this._document.body, s1);
  }

  submitSearch(): void {
    this.search.emit(this.searchInput);
  }

  submitCreate(): void {
    this.create.emit(this.configurationSettingsData.type);
  }

  // by default, the option.id property will be used as the value
  // for options in a <select> tag. If a custom property is assigned
  // to the filter.value, this method determines which property
  // should be used for the value of the option
  getOptionValue(filter: any, option: any): any {
    return filter.value ? option[filter.value] : option.id;
  }

  get paramsMap() {
    return {
      jobs: this.jobParams,
    };
  }

  fetch(model: AutoCompleteFetchModel) {
    const { namespace, search } = model;
    let params = this.paramsMap[namespace];
    params = { ...params, search };
  }

  fetchNext(model: AutoCompleteFetchModel) {
    const { namespace, page } = model;
    let params = this.paramsMap[namespace];
    params = { ...params, page };
  }
}
